





































import { defineComponent, inject, onMounted, computed } from '@vue/composition-api';
import { $K18n } from '@k18n/vue2-k18n-next';
import cookies from 'js-cookie';
import { showErrorToast, yoda } from '@/utils/yoda';
import kwailog from '@/utils/kibtLogger';
import { addParam, getQueryParams } from '@/utils/util';
import useStore from './store';
import { getLangCode } from '@/utils/getLanguage';
import Loading from '@/components/common/loading/Loading.vue';
import MyInfo from '../components/MyInfo.vue';
import OutMission from '../components/OutMission.vue';
import Box from '../components/Box.vue';
import Mission from '../components/Mission.vue';
import { shareOpen, shareCallback } from '../service';
import share from '@/utils/share';
import TopBar from '../components/TopBar.vue';
import { PAGE_SHARE_PARAMS, PAGE_HOME, SHARE_CAPTION, SHARE_TOTAL_MAP, DEFAULT_BANNER, DEFAULT_SHARE } from '../config';
import { isInApp, isYodaEnv } from '@/utils/env';

export default defineComponent({
    name: 'midyear-warmup',
    components: {
        Loading,
        MyInfo,
        Box,
        Mission,
        TopBar,
        OutMission,
    },
    setup() {
        const $k18n = inject('$k18n') as $K18n;
        document.title = $k18n({ id: 'k_333268' });

        kwailog.sendPv({
            page: 'MIDYEAR_BUCKET_COLLECT',
            type: 'enter',
        });

        const langCode = getLangCode();

        const code = langCode?.split('-')[0];

        const query = getQueryParams();
        const { uuid = '', shareBucket = '', livesec = '', source = '', isLiving } = query;

        const store = useStore();

        store.setLivingRoom(isLiving === 'true');
        store.setEnv(isInApp);
        store.setBucket(shareBucket || cookies.get('bucket'));

        store.setPageSecondType(!!livesec); // 是否是二级页访问

        const curBucket = computed(() => {
            return store.homeData.bucket || cookies.get('bucket') || store.shareBucket;
        });

        const shareImg = computed(() => {
            if (!curBucket.value) return DEFAULT_BANNER;
            const obj: any = SHARE_TOTAL_MAP[curBucket.value as keyof typeof SHARE_TOTAL_MAP];
            return obj?.[code as keyof typeof obj] || obj?.en || DEFAULT_SHARE;
        });

        const goShare = () => {
            console.log('share');

            kwailog.sendClick({
                action: 'SHARE',
            });

            const url = `${window.location.origin}${window.location.pathname}?shareBucket=${store.shareBucket}&uuid=${store.homeData.uuid}${PAGE_SHARE_PARAMS}`;
            share({
                key: 'global-mid-warmup',
                siteUrl: url,
                showFriends: true,
                caption: $k18n({ id: SHARE_CAPTION }),
                description: $k18n({ id: 'k_355219' }),
                imageUrl: shareImg.value,
            }, (data: any) => {
                if (data && data.result === 1) {
                    // 分享回调
                    // 分享任务未达上限
                    if (store.canAddSharePoint) {
                        shareCallback()
                            .then(res => {
                                console.log('share callback: ', res);
                                if (res.result === 1) {
                                    store.showSuccessToast('k_336709', store.sharePointVal);
                                    store.updateHomeStorage();
                                    setTimeout(() => {
                                        store.getHomeData();
                                    }, 1500);
                                    localStorage.setItem('global-midyear-my2home', '1');
                                }
                            });
                    } else {
                        setTimeout(() => {
                            store.getHomeData();
                        }, 1500);
                    }
                }
            });
        };

        const goBack = () => {
            if (['WEB_SHARE', 'SHARE'].includes(source)) {
                // 分享打开的当前页是一级页，点击返回跳到主页
                const url = addParam(PAGE_HOME, {
                    ...query,
                    source: 'RULE',
                });
                window.location.replace(url);
                return;
            }
            if (!isYodaEnv) {
                window.history.go(-1);
            } else {
                yoda.component.backOrCloseWeb();
            }
        };

        // 规则页浏览任务 返回后更新数据
        const listenerFn = () => {
            const midyearMy2Home = localStorage.getItem('global-midyear-warmup-ruletask');
            if (midyearMy2Home === '1') {
                setTimeout(() => {
                    store.updateHomeStorage(); // 浏览任务 触发主页更新
                    store.getHomeData();
                    localStorage.removeItem('global-midyear-warmup-ruletask');
                }, 1500);
            }
        };

        onMounted(async () => {
            await yoda.ready();
            store.getHomeData()
                .then(() => {
                    if (store.homeData.result !== 1) {
                        showErrorToast();
                    }
                    kwailog.plugins.radar.fmp();
                });
            // 打开分享者的页面
            if (uuid && store.isInApp) {
                shareOpen(uuid)
                    .then(res => {
                        console.log('分享打开接口: ', res);
                    });
            }
            // 监听storage事件，和二级页联动更新数据
            window.addEventListener('storage', listenerFn);
        });


        return {
            store,
            goShare,
            goBack,
        };
    },
});
